import React, { useEffect, useState } from "react";
import Header from "../../Header";
import { FarmAccordion } from "../../FarmAccordion";
import Data from "../../Data";
import Footer from "../../Footer";
import { useAccount, useBalance, useReadContracts } from "wagmi";
import { POTION_DAO_CHEF_ADDRESS, PTN_TOKEN_ADDRESS } from "../../../Config";
import useCustomContractRead from "../../../Hooks/useCustomContractRead";
import POTION_DAO_CHEF_ABI from "../../../Config/POTION_DAO_CHEF_ABI.json";
import useCustomContractWrite from "../../../Hooks/useCustomContractWrite";
import convertWeiToEther from "../../../Utils/convertWeiToEther";
import Loader from "../../Loader/Loader";
import { Box, Button } from "@mui/material";
import style from "./farm.module.css"
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { NewFooter } from "../../NewFooter";
// import {ZapModal} from "./ZapModal";

const Farm = () => {
  const { address, isConnected } = useAccount();
  const [totalClaimAmount, setTotalCaimAmount] = useState("0");
  const [poolArray, setPoolArray] = useState([]);

  const poolLength = useCustomContractRead({
    Adrress: POTION_DAO_CHEF_ADDRESS,
    Abi: POTION_DAO_CHEF_ABI,
    FuncName: "poolLength",
    onSuccess: (data) => {
      let arr = [];
      for (let i = 0; i < 7; i++) {
        arr.push(i);
      }
      setPoolArray(arr);
    },
  });
  // console.log("poolLength", poolLength?.data);
  

  useEffect(() => {
    if (poolLength?.data) {
      let arr = [];
      for (let i = 0; i < 7; i++) {
        if (i===2) {
          continue
        }
        arr.push(i);
      }
      setPoolArray(arr);
    }
  }, [poolLength?.data])
  

  const {
    executeWrite: harvestAllContractWrite,
    isLoading: isLoadingHarvestAll,
    isSuccess: isSuccessHarvestAll,
    isError: isErrorHarvestAll,
    error: errorHarvestAll,
    txHash: harvestAllWaitForTransaction
  } = useCustomContractWrite({
    address: POTION_DAO_CHEF_ADDRESS,
    abi: POTION_DAO_CHEF_ABI,
    functionName: "harvestAllRewards",
    args: [address],
    // isEnabled: address !== undefined,
  });


  const result = useReadContracts({
    contracts: poolArray?.map((poolIndex) => {
      return {
        address: POTION_DAO_CHEF_ADDRESS,
        abi: POTION_DAO_CHEF_ABI,
        functionName: "pendingReward",
        args: [poolIndex, address],
      };
    }),
    enabled: address !== undefined,
    watch: true,
  });

  useEffect(() => {
    if (result && result?.data && result.data?.length > 0) {
      let total = 0;
      for (let i = 0; i < result?.data?.length; i++) {
        total += parseFloat?.(convertWeiToEther?.(result?.data?.[i]?.result?.toString()));
      }
      setTotalCaimAmount(total);
    }
  }, [result])
  
  

  return (
    <>
      <main className={style.farms}>
        <div className="container  py-4" >
          <div className={style.reward + " d-flex w-75 m-auto justify-content-between align-items-center "}>
            <div className="d-flex gap-2 align-items-center">
              <h3 className="mb-0 fs-4 fw-semibold">Total Rewards</h3>
              <div className="d-flex gap-2 align-items-center">
                <img src="/icons/logo.svg" alt="" />
                <p className="mb-0 fw-semibold"> {totalClaimAmount > 0
                              ? parseFloat?.(totalClaimAmount).toFixed(2)
                              : 0}{" "} SHiELD</p>
              </div>
            </div>
            <button disabled={
                            address !== undefined &&
                            parseFloat?.(totalClaimAmount) > 0 &&
                            !isLoadingHarvestAll 
                              ? false
                              : true
                          }
                          onClick={async () => {
                            try {
                              await harvestAllContractWrite();
                            } catch (error) {
                              //console.log("error",error);
                              
                            }
                          }} className="btn1 py-2 px-3">{(isLoadingHarvestAll) && (
                            <Box sx={{ marginRight: "10px" }}>
                              <Loader color="#423A2A" />
                            </Box>
                          )}
                          Claim All</button>
          </div>
          {poolArray.length > 0 ? (
            <>
              {poolArray?.map((element, index) => {
                return (
                  <>
                    <FarmAccordion
                      key={element}
                      data={Data[element]}
                      poolIndex={element}
                      setTotalCaimAmount={setTotalCaimAmount}
                      index={index}
                    />
                  </>
                );
              })}
            </>
          ) : (<Loader size={"60px"} />)}

          {/* <ZapModal/> */}
        </div>
        <NewFooter/>
      </main>
    </>
  );
};

export default Farm;
